module.exports = __webpack_public_path__ + "Poppins-Regular.add5b696f783a89f3e30.woff";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Poppins-Regular.woff
// module id = ../../../../../src/assets/fonts/Poppins-Regular.woff
// module chunks = main